export default __webpack_public_path__ + "static/media/bag.cfe228f8.png";